import _classCallCheck from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/ContextSelector/context-selector';
import { css } from '@patternfly/react-styles';
import { ContextSelectorContext } from './contextSelectorConstants';
export var ContextSelectorItem =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ContextSelectorItem, _React$Component);

  function ContextSelectorItem() {
    var _this;

    _classCallCheck(this, ContextSelectorItem);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ContextSelectorItem).apply(this, arguments));
    _this.ref = React.createRef();
    return _this;
  }

  _createClass(ContextSelectorItem, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      /* eslint-disable-next-line */
      this.props.sendRef(this.props.index, this.ref.current);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      var _a = this.props,
          className = _a.className,
          children = _a.children,
          _onClick = _a.onClick,
          isDisabled = _a.isDisabled,
          index = _a.index,
          sendRef = _a.sendRef,
          props = __rest(_a, ["className", "children", "onClick", "isDisabled", "index", "sendRef"]);

      return React.createElement(ContextSelectorContext.Consumer, null, function (_ref) {
        var onSelect = _ref.onSelect;
        return React.createElement("li", {
          role: "none"
        }, React.createElement("button", Object.assign({
          className: css(styles.contextSelectorMenuListItem, className),
          ref: _this2.ref,
          onClick: function onClick(event) {
            if (!isDisabled) {
              _onClick(event);

              onSelect(event, children);
            }
          },
          disabled: isDisabled
        }, props), children));
      });
    }
  }]);

  return ContextSelectorItem;
}(React.Component);
ContextSelectorItem.defaultProps = {
  children: null,
  className: '',
  isDisabled: false,
  onClick: function onClick() {
    return undefined;
  },
  index: undefined,
  sendRef: function sendRef() {}
};